import { graphqlFetch } from '@pylot-data/graphqlFetch'
import { categorypost } from '@pylot-data/hooks/blog/graphql/blogQuery'
import { AuthorTree, Maybe } from '@pylot-data/pylotschema'
import type { RequestInit } from '@vercel/fetch'
import { Category } from './get-singlepost'

export interface Blogcategoryposts {
    author: Maybe<AuthorTree>
    identifier?: string
    featured_image: string
    featured_list_image: string
    post_id: string
    title: string
    short_filtered_content: string
    categories?: Category[]
    creation_time: string
    publish_time: string
    modified_time: string
}

export type BlogCategoryTypesForPost = {
    items: Blogcategoryposts[]
    total_count?: number
    total_pages?: number
}

export type BlogCategoriespost = {
    blogPosts: {
        items: Blogcategoryposts[]
    }
}

export type blogcategorypostVariables = {
    currentPage?: number
    pageSize?: number
    categoryId?: number | string
}

export type GetBlogCategoriespost = BlogCategoriespost

async function getCategorypost({
    currentPage,
    pageSize,
    categoryId,
    locale
}: {
    currentPage: number
    pageSize: number
    categoryId?: number | string
    fetchOptions?: RequestInit
    locale?: string
}): Promise<GetBlogCategoriespost | undefined | null> {
    const categorypostDataPromise = graphqlFetch<
        blogcategorypostVariables,
        GetBlogCategoriespost
    >({
        query: categorypost,
        variables: {
            currentPage: currentPage,
            pageSize: pageSize,
            categoryId: categoryId
        },
        locale
    })
    const [categorypostData] = await Promise.all([categorypostDataPromise])
    return categorypostData.data
}

export default getCategorypost
